import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { triggerGAEvent } from '../shared/data-layer-events';
import {
  AfterPageViewModel,
  CTAButtonClickModel,
  EventTypes,
} from '../types/data-layer-models';
import { useCity } from './use-city';
import { checkIsBrowser } from '../helpers';

export const useDataLayer = (): void => {
  if (checkIsBrowser()) {
    window.dataLayer = window.dataLayer || [];
  }
  const router = useRouter();
  const { locale, asPath, events } = router;
  const { cityId, getCity } = useCity();
  const [firstLoad, setFirstLoad] = useState<boolean>(true);

  const handleBtnOrLinkClick = (event: any) => {
    const data: CTAButtonClickModel = {
      event: EventTypes.CTA_BUTTON_CLICK,
      button_click_text: event.target.innerText || event.target.innerHTML,
      button_click_url: event.target?.href || event.srcElement.href,
      block_section: '', // TODO check
      block_title: '', // TODO check
      page_section: asPath,
      page_title: document.title,
      page_url: document.URL,
    };
    triggerGAEvent(data);
  };

  useEffect(() => {
    const handleClick = (event: any) => {
      if (
        event.target instanceof HTMLButtonElement ||
        event.target instanceof HTMLImageElement ||
        event.target.classList.contains('MuiButton-root') ||
        event.target.classList.contains('MuiTypography-root') ||
        event.target.hasAttribute('href')
      ) {
        handleBtnOrLinkClick(event);
      }
    };

    document.addEventListener('click', handleClick, true);

    return () => {
      document.removeEventListener('click', handleClick, true);
    };
  }, []);

  useEffect(() => {
    if (!cityId) return;

    // Function to execute on every page view
    const handleRouteChange = (): void => {
      const data: AfterPageViewModel = {
        event: EventTypes.AFTER_PAGE_VIEW,
        language: locale.toUpperCase() as 'AR' | 'EN',
        location: getCity(cityId)?.name,
        page_section: asPath,
        page_title: document.title,
        page_url: document.URL,
      };
      triggerGAEvent(data);
      setFirstLoad(false);
    };
    // Call handleRouteChange on initial load only
    if (firstLoad) handleRouteChange();

    events.on('routeChangeComplete', handleRouteChange);

    return () => {
      events.off('routeChangeComplete', handleRouteChange);
    };
  }, [cityId, firstLoad, getCity, router]);
};
